import AdminCategoryCard from '@components/AdminCategoryCard/AdminCategoryCard.component';
import { Box, Button, Divider, IconButton, styled, Typography, TextField, InputAdornment, CircularProgress } from '@mui/material';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import AndroidIcon from 'icons/Technologies/Android.icon';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ReusableModal from '@components/Modal/ReusableModal.component';
import React, { useEffect, useState } from 'react';
import SearchIcon from 'icons/Search.icon';
import AddIcon from '@mui/icons-material/Add';
import AdminPageHeader from '@components/AdminPageHeader/AdminPageHeader.component';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { toast } from 'react-toastify';
import NoData from 'icons/NoData.icon';

export const Route = createFileRoute('/(admin)/_admin/technology/$id')({
  component: TechnologyPage,
});

const StyledInterviewCard = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    background: '#fff',
    border: '1px solid var(--Light-Gray)',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0px 2px 4px 0px #0205111F',
    '@media (max-width: 768px)': {
      padding: '16px',
      gap: '16px',
    },
    '@media (max-width: 480px)': {
      padding: '12px',
      gap: '12px',
    }
})

const StepContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '4px',
}));

const StepIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'color',
})<{ isActive?: boolean; color?: string }>(({ isActive = false, color }) => ({
  width: '32px',
  height: '2px',
  backgroundColor: isActive ? color : 'var(--Light-Gray)',
  borderRadius: '0 0 2px 2px',
  '@media (max-width: 480px)': {
    width: '24px',
  }
}));

const CustomButtonStyle = styled(IconButton)({
    border: '1px solid var(--Interviewer-Near-White)',
    borderRadius: '8px',
    width: '24px',
    height: '24px',
    '@media (max-width: 480px)': {
      width: '20px',
      height: '20px',
    }
})

const StyledSearch = styled(TextField)(() => ({
  marginTop: '40px',
  input: {
    lineHeight: '20px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--Interviewer-Lightest-Black)',
  },
  '@media (max-width: 768px)': {
    marginTop: '16px',
  }
}));


function TechnologyPage() {
  const { id: technologyId } = Route.useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);

  //ZA BRISANJE
  // const { id } = Route.useParams();
  // const [categories, setCategories] = React.useState<{id: string, name: string, description?: string}[]>([]);
  // const [isLoadingCategories, setIsLoadingCategories] = React.useState(false);
  // const [errorCategories, setErrorCategories] = React.useState('');
  // const [linkingCategoryId, setLinkingCategoryId] = React.useState<string | null>(null);
  // const [linkError, setLinkError] = React.useState<string | null>(null);
  // const [existingCategories, setExistingCategories] = useState([])




  //Novo
  //Podaci o tehnologiji
  const { data: technology, isPending} = useQuery({
    queryKey: ['admin-technology'],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const results = await axios.get(`https://interviewer.runasp.net/api/technologies/${technologyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      console.log('Tehnologija podaci', results);
      return results.data;
    },
  })

  //Podaci za intervjue
  const { data: interviews, isLoading, error } = useQuery({
    queryKey: ['admin-technology-interviews', technologyId],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://interviewer.runasp.net/api/technologies/${technologyId}/interviews`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    },
    enabled: !!technologyId,
  });

  // Podaci za postojece (globalne) kategorije - modal
  const { data: existCategories } = useQuery({
    queryKey: ['existing-categories'],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const results = await axios.get(`https://interviewer.runasp.net/api/categories`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log('Postojece globalne kategorije', results);
      return results.data;
    },
    enabled: isModalOpen,
  });


  //Podaci za kategorije koje su linkovane sa tehnologijim
  const { data: linkedCategories, isLoading: isLoadingLinkedCategory,  } = useQuery({
    queryKey: ['technology-categories', technologyId],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://interviewer.runasp.net/api/technologies/${technologyId}/categories`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log('Linkovane kategorije', response.data);
      return response.data;
    },
    enabled: !!technologyId,
  });

  // Id svih linkovanih kategorija
  const linkedCategoryIds = linkedCategories?.map(cat => cat.id) || [];


  //Linkovanje kategorije za postojecu tehnologiju
  const linkCategoryMutation = useMutation({
    mutationFn: async (categoryId: string) => {
      console.log(technologyId, categoryId);

      const token = localStorage.getItem('token');
      const response = await axios.put(`https://interviewer.runasp.net/api/technologies/${technologyId}/link-category`,
        { categoryId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      return response;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['technology-categories', technologyId] });
      toast.success('Successfully linked category!')
    },
    onError: (error) => {
      console.log('aadassada', error);
      
      toast.error('We have problem to link category!')
      console.log(error);
    }
  })

  //Brisanje intervjua
  const handleDeleteInterview = (interviewId: string, id: string) => {
    deleteMutation.mutate({interviewId, id});
  }

  const deleteMutation = useMutation({
    mutationFn: async ({interviewId} : {interviewId : string, id : string}) => {
      const token = localStorage.getItem('token');
      const results = await axios.delete(`https://interviewer.runasp.net/api/interviews/${interviewId}`, {
          headers: {
              Authorization: `Bearer ${token}`,
          }
      });
      return results;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin-technology-interviews', variables.id] });
      toast.success('Successfully deleted interview!');
    },
    onError: (error) => {
      console.log(error);
    }
  })

  //Brisanje linkovane kategorije - unlink
  const handleDeleteCategory = (categoryId: string) => {
     deleteCategoryMutation.mutate(categoryId);
  }

  const deleteCategoryMutation = useMutation({
    mutationFn: async (categoryId: string) => {
      const token = localStorage.getItem("token");
      return axios.delete(
        `https://interviewer.runasp.net/api/categories/${categoryId}/technologies/${technologyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['technology-categories', technologyId]})
      toast.success('Successfully unlinked category!')
    },
    onError: (err) => {
      console.log("Delete error:", err);
    },
  })

  return (
    <Box>
      <AdminPageHeader
        title="Single Technology View"
        icon={<ArrowBackIcon color="primary" fontSize="medium" />} 
        onIconClick={() => navigate({ to: '/admin-dashboard' })}
      />

      <Box sx={{
        px: {
          xs: '16px',
          sm: '24px',
          md: '32px'    
        },
        py: {
          xs: '16px',
          sm: '24px',
          md: '32px'
        }
      }}>
        <Box sx={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          pb: '24px',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: '16px', sm: '0' }
        }}>
          <Typography variant="h2" sx={{ 
            textAlign: { xs: 'center', sm: 'left' }
          }}>
            {technology?.name}  Interviews
          </Typography>
          <Button 
            variant='contained'
            sx={{
              width: { xs: '100%', sm: 'auto' },
              minWidth: { sm: '200px' }
            }}
          >
            Create a new interview
          </Button>
        </Box>
        <Divider orientation="horizontal" sx={{
          borderColor: 'var(--Interviewer-Near-White)',
        }}/>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(auto-fit, minmax(300px, 1fr))',
              md: 'repeat(auto-fit, minmax(350px, 1fr))',
              lg: 'repeat(auto-fit, minmax(400px, 1fr))'
            },
            gap: {
              xs: '16px',
              sm: '20px',
              md: '24px'
            },
            mt: '24px'
          }}
        >
          {isLoading && <Typography>Loading interviews...</Typography>}
          {error && <Typography color="error">Failed to load interviews</Typography>}
          {interviews && interviews.length === 0 && <Typography>No interviews found.</Typography>}
          {interviews && interviews.map((interview: any) => (
            <StyledInterviewCard key={interview.id}>
              <Box sx={{
                display: 'flex', 
                justifyContent:'space-between', 
                gap: { xs: '16px', sm: '24px' },
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'stretch', sm: 'flex-start' },
                flexWrap: 'wrap'
              }}>
                <Box sx={{
                  display: 'flex', 
                  gap: { xs: '16px', sm: '24px' },
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: { xs: 'center', sm: 'flex-start' },
                  flex: '1',
                  minWidth: 0
                }}>
                  <Box sx={{ flexShrink: 0 }}>
                    <AndroidIcon />
                  </Box>
                  <Box sx={{
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '6px',
                    alignItems: { xs: 'center', sm: 'flex-start' },
                    textAlign: { xs: 'center', sm: 'left' },
                    minWidth: 0,
                    flex: '1'
                  }}>
                      <StepContainer>
                        {[0, 1, 2].map((step) => (
                          <StepIndicator
                            key={step}
                            isActive={step < 1}
                            color='#31C07D'
                          />
                        ))}
                      </StepContainer>
                      <Typography sx={{
                        fontWeight: '700', 
                        color: 'var(--Interviewer-Black)',
                        fontSize: { xs: '1rem', sm: '1.125rem' },
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word'
                      }}>
                        {interview.name || 'Untitled Interview'}
                      </Typography>
                      <Typography sx={{
                        fontWeight: '500', 
                        color: 'var(--Interviewer-Lighter-Black)', 
                        fontSize: '12px'
                      }}>
                        Difficulty: {interview.difficulty}
                      </Typography>
                  </Box>
                </Box>
                <Box sx={{
                  display: 'flex', 
                  gap: '8px',
                  justifyContent: { xs: 'center', sm: 'flex-end' },
                  flexShrink: 0
                }}>
                  <CustomButtonStyle onClick={() => {
                    navigate({ 
                      to: '/create-interview', 
                      search: { interviewId: interview.id } 
                    });
                  }}>
                      <ModeEditOutlineOutlinedIcon fontSize="small" color="primary" sx={{width: '12px', height: '12px'}} />
                  </CustomButtonStyle>
                  <CustomButtonStyle onClick={() => handleDeleteInterview(interview.id, technologyId)}>
                      <DeleteOutlineOutlinedIcon fontSize="small" color="primary" sx={{width: '18px', height: '18px'}} />
                  </CustomButtonStyle>
                </Box>
              </Box>
              <Divider orientation="horizontal" sx={{
                borderColor: 'var(--Interviewer-Near-White)',
              }}/>
              <Box sx={{
                textAlign: { xs: 'center', sm: 'left' },
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
                  {interview.description}
              </Box>
            </StyledInterviewCard>
          ))}
        </Box>
        
        <Box sx={{
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          pt: '45px', 
          pb: '24px',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: { xs: '16px', sm: '0' }
        }}>
          <Typography variant="h2" sx={{ 
            textAlign: { xs: 'center', sm: 'left' }
          }}>
            {technology?.name}  Categories
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: '16px',
            flexDirection: { xs: 'column', sm: 'row' },
            width: { xs: '100%', sm: 'auto' }
          }}>
            <Button 
              variant='outlined' 
              sx={{
                backgroundColor: 'var(--Light-Gray)',
                border: 'none',
                color: 'var(--Interviewer-Black)',
                fontWeight: 600,
                fontSize: '14px',
                width: { xs: '100%', sm: 'auto' }
              }}
              onClick={() => navigate({ 
                to: '/create-category', 
                search: { technologyId: id, categoryId: undefined } 
              })}
            >
              Create a new category
            </Button>
            <Button 
              variant='contained'
              onClick={() => setModalOpen(true)}
              sx={{
                width: { xs: '100%', sm: 'auto' }
              }}
            >
              Link existing category
            </Button>
          </Box>
        </Box>
        
        <ReusableModal open={isModalOpen} onClose={() => setModalOpen(false)}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h2" sx={{fontSize: '24px'}}>
              Link existing category
            </Typography>
            <Typography sx={{fontSize: '14px'}}>
              Link a category from the list or search for a specific category
            </Typography>
          </Box>
          <StyledSearch
            fullWidth
            type="search"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            placeholder="Search for a category"
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              mt: '20px',
              width: '100%',
              maxHeight: '400px',
              overflowY: 'auto',
            }}
          >
            {existCategories?.map(category => {
                const isLinked = linkedCategoryIds.includes(category.id);
                return (
                  <Box key={category.id} sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: { xs: 1.5, sm: 2 },
                    border: '1px solid var(--Light-Gray)',
                    borderRadius: '8px',
                    gap: {xs: '4px', md: '0px'},
                    opacity: isLinked ? 0.5 : 1,
                  }}>
                    <Box>
                      <Typography variant="h3" sx={{pb: '8px'}}>
                        {category.name}
                      </Typography>
                      <Typography sx={{fontSize: '14px'}}>
                        {category.description}
                      </Typography>
                    </Box>
                    <IconButton
                      color="primary"
                      onClick={() => linkCategoryMutation.mutate(category.id)}
                      disabled={isLinked}
                      sx={{
                        backgroundColor: 'black',
                        color: 'white',
                        borderRadius: '50%',
                        p: '8px',
                        width: '40px',
                        height: '40px',
                        '&:hover': {
                          backgroundColor: 'var(--Light-Gray)',
                        },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>
                );
              })
             }
          </Box>
        </ReusableModal>

        <Divider orientation="horizontal" sx={{
          borderColor: 'var(--Interviewer-Near-White)',
          mb: '24px'
        }}/>

        <Box sx={{
          display: 'flex', 
          flexDirection: 'column', 
          gap: '8px'
        }}>
          {isLoadingLinkedCategory && <CircularProgress />}
          {linkedCategories && linkedCategories.length === 0 && <NoData />}
          {linkedCategories && linkedCategories.map((category: any) => (
            <AdminCategoryCard 
              key={category.id} 
              id={category.id}
              name={category.name} 
              description={category.description} 
              onDelete={handleDeleteCategory}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
} 